// @ts-nocheck

import { type StateType } from '../../../states';
import { type BasketState } from '../../../states/basket';
import { type MatchId } from '../../../states/entities/matches';
import { type GenericAction } from '../../../types/redux';

import basketAddBetbuilderItem from './basketAddBetbuilderItem';
import basketAlterCachedMMAPIResponseInfos from './basketAlterCachedMMAPIResponseInfos';

const computeNextState = (state: BasketState, matchId: MatchId) => {
  const itemIds = Object.keys(state.items);
  const nextItemsAsArr = itemIds.reduce(
    (acc, itemId) => (state.items[itemId].matchId !== matchId ? [...acc, { ...state.items[itemId] }] : acc),
    [],
  );

  if (nextItemsAsArr.length !== itemIds.length) {
    const nextItems = {};

    for (const nextItem of nextItemsAsArr) {
      nextItems[nextItem.oddId] = nextItem;
    }

    return {
      ...state,
      items: nextItems,
    };
  }

  return state;
};

const basketInjectTopMyMatch = (state: BasketState, action: GenericAction, globalState: StateType) => {
  const { payload } = action;
  const { matchId, outcomes, value } = payload ?? {};

  let nextState = computeNextState(state, matchId);

  nextState = basketAddBetbuilderItem(
    nextState,
    {
      payload: {
        matchId,
        selectionItems: outcomes,
        value,
        source: undefined,
        ts: Date.now(),
      },
    },
    globalState,
  );

  nextState = basketAlterCachedMMAPIResponseInfos(nextState, {
    payload: {
      matchId,
      result: {
        mymatchOdds: value,
      },
      outcomes,
    },
  });

  return nextState;
};

export default basketInjectTopMyMatch;
